import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ChefHat } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const NotFoundPage = () => {
  const { t } = useLanguage();

  return (
    <div
      data-testid="not-found-page"
      className="min-h-[80vh] flex items-center justify-center bg-[#FAFAF8]"
    >
      <div className="container mx-auto px-4 md:px-8 py-24 text-center">
        <div className="max-w-xl mx-auto">
          <div className="mb-6">
            <ChefHat className="w-20 h-20 mx-auto text-amber-600/50" />
          </div>
          <h1 className="text-8xl font-bold text-amber-600/30 mb-2">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            {t('notFoundTitle')}
          </h2>
          <p className="text-gray-600 mb-8">
            {t('notFoundDescription')}
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-colors"
          >
            <Home className="w-5 h-5" />
            {t('notFoundGoHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};
